import React, { useContext } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { AppContext } from "../App";
import { TbTemperatureCelsius } from "react-icons/tb";
const Sidebar = () => {
  const { submit, input, setinput, data } = useContext(AppContext);

  return (
    <div>
      <form action="" onSubmit={submit} className="form">
        <input
          type="search"
          value={input}
          className="input"
          placeholder="Enter Location"
          onChange={(e) => {
            setinput(e.target.value);
          }}
        />
        <button type="submit" className="button">
          <BiSearchAlt />
        </button>
      </form>

      <div className="country">
        <p onClick={() => setinput("mumbai")}>Mumbai</p>
        <p onClick={() => setinput("london")}>London</p>
        <p onClick={() => setinput("new york")}>New York</p>
        <p onClick={() => setinput("tokyo")}>Tokyo</p>
      </div>

      <h3>Weather Details</h3>
      <div className="weather-detail">
        <p>Min Temp <span>{data?.main.temp_min} <TbTemperatureCelsius /></span></p>
        <p>Max Temp<span>{data?.main.temp_max} <TbTemperatureCelsius /></span></p>
        <p>Wind <span>{data?.wind.speed} Km / h</span></p>
        <p>Humidity <span>{data?.main.humidity} %</span></p>
        {/* <p>Cloudy <span>{data?.main.humidity} %</span></p> */}
      </div>
    </div>
  );
};

export default Sidebar;
